import './Footer.css';

const Footer = () => {
    return (
        <div className='footer-container'>
            <span>
                <a className='footer-link' href='https://www.tomerhalali.com/' target='_blank' rel='noreferrer'>
                    @ Powered by Tomer Halali
                </a>
            </span>
        </div>
    );
};

export default Footer;
